import Vue from 'vue';
import VueRouter from 'vue-router';
import Step1 from '../views/Step1.vue';
import Step2 from '../views/Step2.vue';
import Step3 from '../views/Step3.vue';
import ThankYou from '../views/ThankYou.vue';
import Error from '../views/Error.vue';

Vue.use(VueRouter);

const routes = [
  {
    name: 'Step1',
    path: '/zakladne-udaje',
    component: Step1,
    meta: {
      step: 1,
      label: 'Základné údaje',
    },
  },
  {
    name: 'Step2',
    path: '/instrukcie-a-prehlad-fotografii',
    component: Step2,
    meta: {
      step: 2,
      label: 'Inštrukcie a prehľad fotografií',
    },
  },
  {
    name: 'Step3',
    path: '/upload-fotografii',
    component: Step3,
    meta: {
      step: 3,
      label: 'Upload fotografií',
    },
  },
  {
    name: 'Step4',
    path: '/dakujeme',
    component: ThankYou,
    meta: {
      step: 4,
    },
  },
  {
    name: 'Error',
    path: '/error',
    component: Error,
    meta: {
      step: 5,
    },
  },
  {
    name: 'Other',
    path: '*',
    redirect: '/zakladne-udaje',
  },
];
const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.goToStep = (step, params) => {
  const { query } = router.app.$route;
  const route = router.options.routes.find((r) => r.meta?.step === step);
  if (route.name !== router.currentRoute.name) {
    router.push({ name: route.name, params: params || {}, query });
  }
};

router.beforeEach((to, from, next) => {
  /*
  * If user is in Error page or ThankYou page block router from leaving
  * */
  if (from.name === 'Step4' && from.query.hash !== undefined) {
    next();
  }
  if (from.name === 'Error' && to.name === 'Step1') next();
  if (from.name === 'Error' || from.name === 'Step4') return;
  next();
});

export default router;
